import { TypographyInlineCode } from '@/components/ui/typography';

import { Faq } from './types';

export const faqs: Faq[] = [
  {
    id: 1,
    key: 'seats',
    question: 'What are seats?',
    answer:
      'Each team member who logs in to FlagSync with a unique email address counts as a seat. Unlike most feature management platforms, there are no minimum seat requirements for any tier.',
  },
  {
    id: 2,
    key: 'mau',
    question: 'How do you calculate Monthly Active Users (MAUs)?',
    answer:
      'We track the number of unique keys (usually user identifiers) evaluated by our SDKs within a 30-day period. Each unique key can evaluate multiple flags any number of times during the 30-day period, yet will still be counted as a single MAU.',
  },
  {
    id: 3,
    key: 'free-trial',
    question: 'What happens if I exceed the MAU limit in my plan?',
    answer:
      'Almost nothing! We’ll notify you when you’re approaching your limit. If you exceed your MAU limit, no unexpected charges will be incurred. If you consistently exceed your limit, we’ll work with you to find the best solution.',
  },
  {
    id: 4,
    key: 'events',
    question: 'What are events?',
    answer: (
      <>
        Events are sent to FlagSync when the{' '}
        <TypographyInlineCode className="text-greenhorn-600">
          track
        </TypographyInlineCode>{' '}
        function is called from the SDK; they are critical for tracking how
        feature rollouts affect user behavior. Apart from providing real-time
        insights, events can be linked to{' '}
        <span className="font-bold text-greenhorn-600">metrics</span> for{' '}
        <span className="font-bold text-greenhorn-600">experiments</span>.
      </>
    ),
  },
  {
    id: 5,
    key: 'metrics',
    question: 'What are metrics?',
    answer: (
      <>
        Metrics are essential for understanding how feature rollouts impact user
        behavior, helping to identify the optimal settings for your flags.
        Created from{' '}
        <span className="font-bold text-greenhorn-600">events</span>, they allow
        you to measure and aggregate various aspects of your application, such
        as page load times, conversion rates, or purchase amounts.
      </>
    ),
  },
  {
    id: 6,
    key: 'experiments',
    question: 'What are experiments?',
    answer: (
      <>
        Experiments allow you to compare the variants of a feature flag to
        determine which one performs best. Created with{' '}
        <span className="font-bold text-greenhorn-600">metrics</span>, they
        enable data-driven decision-making, ensuring that each feature rollout
        maximizes user engagement and business objectives.
      </>
    ),
  },
  {
    id: 7,
    key: 'free-trial',
    question: 'Can I try FlagSync for free?',
    answer:
      'Yes! Every tier includes a 14-day free trial, no credit card required. You can upgrade or downgrade your plan at any time, and there are no minimum seat requirements for any tier.',
  },
];
